import {
  Carrot, Croissant, ChefHat, ShoppingBasket, Home, Sparkles, Shirt,
  Palette, Baby, Wrench, Package, Store,
} from "lucide-react";

const map = {
  Carrot, Croissant, ChefHat, ShoppingBasket, Home, Sparkles, Shirt,
  Palette, Baby, Wrench, Package, Store,
};

export function CatIcon({ name, ...props }) {
  const Icon = map[name] || Store;
  return <Icon {...props} />;
}
